import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import index from '@/components/mode/index'
import discount from '@/components/mode/discount'
import wallet from '@/components/mode/wallet'
import mine from '@/components/mode/mine'
import message from '@/components/mode/message'
import electronics from '@/components/mode/electronics'
import discountInfo from '@/components/mode/discountInfo'
import withdraw from '@/components/mode/withdraw'
import transfer from '@/components/mode/transfer'
import customer from '@/components/mode/customer'
import apply from '@/components/mode/apply'
import about from '@/components/mode/about'
import setting from '@/components/mode/setting'
import applyList from '@/components/mode/applyList'
import account from '@/components/mode/account'
import vip from '@/components/mode/vip'
import bankCard from '@/components/mode/bankCard'
import addUsdtAds from '@/components/mode/addUsdtAds'
import addBankCard from '@/components/mode/addBankCard'
import meyList from '@/components/mode/meyList'
import welfare from '@/components/mode/welfare'
import kefu from '@/components/mode/kefu'
import hongbao from '@/components/mode/hongbao'





import login from '@/components/login'
import gamePage from '@/components/gamePage'


import app from '@/components/app'
import payInfo from '@/components/payInfo'





Vue.use(Router)

export default new Router({
  // mode: 'history',
  mode: 'hash',

  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      children: [
        {
          path: '/',
          name: 'index',
          component: index,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch:false//是否用缓存
          }
        },{
          path: '/discount',
          name: 'discount',
          component: discount,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch:false//是否用缓存
          }

        },{
          path: '/wallet',
          name: 'wallet',
          component: wallet,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch:false//是否用缓存
          }
        },{
          path: '/mine',
          name: 'mine',
          component: mine,

        },{
          path: '/message',
          name: 'message',
          component: message,

        },{
          path: '/electronics',
          name: 'electronics',
          component: electronics,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch:false//是否用缓存
          }
        },{
          path: '/discountInfo',
          name: 'discountInfo',
          component: discountInfo,
        },{
          path: '/withdraw',
          name: 'withdraw',
                    meta: {
            requireAuth: true,
          },
          component: withdraw,
        },{
          path: '/transfer',
          name: 'transfer',
          meta: {
            requireAuth: true,
          },
          component: transfer,
        },{
          path: '/customer',
          name: 'customer',
          component: customer,
        },{
          path: '/apply',
          name: 'apply',
          component: apply,
        },{
          path: '/setting',
          name: 'setting',
          component: setting,
        },{
          path: '/about',
          name: 'about',
          component: about,
          
        },{
          path: '/applyList',
          name: 'applyList',
          component: applyList,
        },{
          path: '/account',
          name: 'account',
          component: account,
        },{
          path: '/vip',
          name: 'vip',
          component: vip,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch:false//是否用缓存
          }
        },{
          path: '/bankCard',
          name: 'bankCard',
          component: bankCard,
        },{
          path: '/addBankCard',
          name: 'addBankCard',
          component: addBankCard,
        },{
          path: '/addUsdtAds',
          name: 'addUsdtAds',
          component: addUsdtAds,
        },{
          path: '/meyList',
          name: 'meyList',
          component: meyList,
        },{
          path: '/welfare',
          name: 'welfare',
          component: welfare,
        },{
          path: '/kefu',
          name: 'kefu',
          component: kefu,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch:false//是否用缓存
          }
        },{
          path: '/hongbao',
          name: 'hongbao',
          component: hongbao,
          meta: {
            requireAuth: true,
          },
        }, {
          path: '/payInfo',
          name: 'payInfo',
          component: payInfo,
        }
      ]
    }, {
      path: '/login',
      name: 'login',
      component: login,
    }, {
      path: '/gamePage',
      name: 'gamePage',
      component: gamePage,
    },{
      path: '/app',
      name: 'app',
      component: app,
    }
    , {
      path: '*', // 重定向页面地址
      redirect: '/'
    }


  ]
})





// WEBPACK FOOTER //
// ./src/router/index.js